export default __webpack_public_path__ + "i18n/translation-ar.62ba74dd.json";